export default __webpack_public_path__ + "static/Dr.ArvindLal-9d0c38d1c1d9bb5f1929aa393fdffac6.png";